import { render, staticRenderFns } from "./PsAdministrationSubscriptionsList.vue?vue&type=template&id=0702764d&scoped=true&"
import script from "./PsAdministrationSubscriptionsList.vue?vue&type=script&lang=js&"
export * from "./PsAdministrationSubscriptionsList.vue?vue&type=script&lang=js&"
import style0 from "./PsAdministrationSubscriptionsList.vue?vue&type=style&index=0&id=0702764d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0702764d",
  null
  
)

export default component.exports